import styled from "@emotion/styled";
import { Direction, TokenStackedArray } from "components/general/TokenStackedArray";
import React from "react";
import { FlexContainer } from "../../../containers/FlexContainer";
import { useIsTradeHistoryReturned } from "../../../hooks/useIsTradeHistoryReturned";
import { TokenHistoryInfo } from "../../../types/history";
import { FlexColumnBetween } from "../../general/FlexColumnBetween/FlexColumnBetween";
import { SkeletonCircle } from "../../general/Skeleton";
import { TokensBoughtOrSold } from "./TokensBoughtOrSold";
import { Chain } from "viem/chains";

export interface BuyTokensCellProps {
  tokenHistoryInfo: TokenHistoryInfo;
  columnId: string;
  chainId: Chain["id"];
}

export const BuyTokensOrSellTokensCell: React.FC<BuyTokensCellProps> = React.memo(
  ({ tokenHistoryInfo, chainId }) => {
    const isTradeHistoryReturned = useIsTradeHistoryReturned();
    return (
      <Container>
        <FlexColumnBetween>
          {isTradeHistoryReturned ? (
            <TokenStackedArray
              chainId={chainId}
              direction={Direction.Vertical}
              tokenHistory={tokenHistoryInfo}
              tokenSize={28}
            />
          ) : (
            <SkeletonIcon>
              <SkeletonCircle width={25} height={25} />
            </SkeletonIcon>
          )}
        </FlexColumnBetween>
        <TokensBoughtOrSold tokenHistoryInfo={tokenHistoryInfo} chainId={chainId} />
      </Container>
    );
  }
);

// Sub-components

const Container = styled(FlexContainer)`
  min-width: 108px;
  width: 100%;
`;

const SkeletonIcon = styled.div`
  width: 25px;
  height: 25px;
`;
